<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container">
      <asideCom :activityIndex="10"></asideCom>
      <div class="my-content">
        <div class="top-choose">
          <div class="message" :class="{'choose':titleIndex===0}" @click="changeIndex(0)">{{$t('global.我参加的竞赛')}}</div>
        </div>
        <div class="joincompetition">
          <table>
            <thead>
              <tr>
                <td class="width32">{{$t('global.竞赛名称')}}</td>
                <td class="width32">{{$t('global.投稿作品')}}</td>
                <td class="width12">{{$t('global.竞赛状态')}}</td>
                <td class="width12">{{$t('global.参赛结果')}}</td>
                <td class="width16">{{$t('global.操作')}}</td>
              </tr>
            </thead>
            <tr v-for="item in list" :key="item.id">
              <td class="width32">
                <router-link
                  class="matchName"
                  :to="'/match/'+item.matchUrl"
                  target="_blank"
                >{{language === "zh" ? item.matchTitle : item.matchEnTitle || item.matchTitle}}</router-link>
              </td>
              <td class="width32">
                <p>
                  <router-link
                    class="videoName"
                    :to="'/video/detail?id='+item.videoId"
                    target="_blank"
                  >{{language === "zh" ? item.videoTitle:item.enVideoTitle||item.videoTitle}}</router-link>
                </p>
              </td>
              <td>
                {{
                getMatchStatusText(item)
                }}
              </td>
              <td>{{getStatusText(item)}}</td>
              <td class="operate">
                <a href="javascript:;" @click="editMatch(item)" v-if="getStatus(item)">{{$t('global.编辑')}}</a>
                <a
                  href="javascript:;"
                  @click="goToPay(item)"
                  v-if="item.isPay === null && item.matchId === 1005 && Date.now()<item.endTime"
                >{{$t('global.去支付')}}</a>
                <br />
                <a href="javascript:;" @click="goOut(item)" v-if="getStatus(item,1)">{{$t('global.退出竞赛')}}</a>
              </td>
            </tr>
          </table>
          <pages
            :page-size="pagerParam.pageSize"
            :page-count="pagerParam.pageCount"
            :current-page="pagerParam.currentPage"
            :total="pagerParam.total"
            @current-page-changed="currentPageChanged"
          ></pages>
        </div>

        <!-- 笑脸 -->
        <content-empty v-if="list.length == 0" :content="$t('global.没有参与的比赛')"></content-empty>
      </div>
    </div>
    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import asideCom from "@/components/aside.vue";
import pages from "@/components/pages.vue";
import ContentEmpty from "@/components/ContentEmpty.vue";

export default {
  name: "MyLike",
  metaInfo() {
    return {
      title: this.$t("global.我的比赛") + " | MANA"
    };
  },
  data() {
    return {
      contentIndex: 0,
      titleIndex: 0,
      list: [],
      userId: "",
      orderList: [
        { name: this.$t('global.最新创作'), imgType: "/static/peopleCenter/new.png" },
        { name: this.$t('global.按浏览量'), imgType: "/static/peopleCenter/eye.png" },
        { name: this.$t('global.按点赞数'), imgType: "/static/peopleCenter/hand.png" },
        { name: this.$t('global.按评论数'), imgType: "/static/peopleCenter/message.png" }
      ],
      pagerParam: {
        pageSize: 6,
        pageCount: 1,
        currentPage: 1,
        total: 1
      }
    };
  },
  components: {
    MainLayout,
    service,
    asideCom,
    pages,
    ContentEmpty
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getCompetition();
      this.userId =
        this.$store.state.peopleMessage &&
        this.$store.state.peopleMessage.userId;
    },
    goToPay(item) {
      this.$router.push(
        `/match/${item.matchUrl}/enter?videoId=${item.videoId}&step=4`
      );
    },
    getCompetition() {
      this.$http
        .get(
          "/api/u/getMatchVideo?pageIndex=" +
            this.pagerParam.currentPage +
            "&pageSize=" +
            this.pagerParam.pageSize
        )
        .then(response => {
          this.list = response.data.list;
          this.pagerParam = {
            pageSize: response.data.pageSize,
            pageCount: response.data.totalPage,
            currentPage: response.data.pageIndex,
            total: response.data.totalRecord
          };
        });
    },
    currentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.getCompetition();
    },
    goOut(item) {
      const url = `/api/match/video/outMatch`;
      const queryObj = {
        videoId: item.videoId,
        matchId: item.matchId
      };
      if (confirm(this.$t('global.确定退出竞赛'))) {
        this.$http.post(url, queryObj).then(res => {
          if (res.code === "OK") {
            this.$message({
              message: this.$t("global.操作成功"),
              type: "success",
            });
            this.getCompetition();
          }
        });
      }
    },
    getStatus(item, out) {
      // const now = Date.now();
      // const flag = now < item.endTime || now > item.overTime;
      // if (out && (now > item.overTime || item.isPay === 0)) {
      //   return false;
      // }
      // return flag;
      const flag = item.matchState == 2;
      if (out && (!flag|| item.isPay === 0)) {
        return false
      }
      return flag
    },
    getMatchStatusText(item) {
      // return Date.now() >= item.startTime && Date.now() < item.endTime
      //   ?this.$t('global.投稿中')
      //   : Date.now() > item.endTime && Date.now() < item.publishStartTime
      //   ?this.$t('global.评审中')
      //   : Date.now() >= item.publishStartTime && Date.now() < item.overTime
      //   ?this.$t('global.获奖作品公布')
      //   : Date.now() > item.overTime
      //   ?this.$t('global.已结束')
      //   : null;
      var text = ""
      if(item.matchState == 2) {
        text = this.$t('global.投稿中')
      }
      if(item.matchState == 3 || item.matchState == 4) {
        text = this.$t('global.评审中')
      }
      if(item.matchState == 5) {
        text = this.$t('global.获奖作品公布')
      }
      if(item.matchState == 6) {
        text = this.$t('global.已结束')
      }
      return text
    },
    getStatusText(item) {
      var text = "";
      if (item.status == 2) {
          text = this.$t('global.投稿成功')
      }
      if (item.status == 1) {
          text = this.$t('global.审核中')
      }
      return text
      // if (item.matchState == 2) {
      //   if (item.status == 2) {
      //     text = this.$t('global.投稿成功')
      //   }
      //   if (item.status == 1) {
      //     text = this.$t('global.审核中')
      //   }
      // }
      // if (item.matchState == 3 || item.matchState == 4) {
      //   //TODO: 入围时间有可能为空
      //   if (Date.now() > item.candidatePromulgateTime) {
      //       if (item.status == 1) {
      //         text =  this.$t('global.未入围');
      //       }
      //       if (item.status == 2) {
      //         text = this.$t('global.已入围');
      //       }
      //     } else {
      //      text = this.$t('global.投稿成功');
      //     }
      // }
      // if (item.matchState == 5 || item.matchState == 6) {

      // }
      // if (item.isPay === null && item.matchId === 1005) {
      //   if (Date.now() > item.endTime) {
      //     return `${this.$t('global.未支付')}，${this.$t('global.投稿失败')}`;
      //   } else {
      //     return this.$t('global.待支付');
      //   }
      // }
    },
    editMatch(item) {
      const url = `/match/${item.matchUrl}/enter?videoId=${item.videoId}`;
      this.getStatus(item) ? this.$router.push(url) : null;
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.order {
  display: flex;
  /* width 16rem */
  overflow: hidden;
  margin: 0 auto;
  color: #777777;
  line-height: 0.17rem;

  .sort {
    color: #0060ff;
    font-weight: bold;
  }

  >div {
    cursor: pointer;
    margin: 0.5rem 0 0 0.3rem;

    &:first-child {
      margin: 0.5rem 0 0 0;
    }
  }

  img {
    width: 0.16rem;
    margin-top: -0.04rem;
  }

  span {
    display: inline-block;
    margin-left: 0.1rem;
  }
}

.play-record-head {
  display: flex;
  justify-content: space-between;
  font-size: 0.2rem;
  margin: 0.5rem 0 0.2rem;

  .delete {
    color: #0060ff;
  }
}

.my-content {
  width: 870px;
  background-color: #ffffff;
  padding: 0.5rem 0.6rem;
  border-radius: 0.08rem;

  .top-choose {
    font-size: 18px;
    color: #333;

    div {
      cursor: pointer;
    }

    span {
      display: block;
      margin: 0 0.65rem;
    }

    .choose {
      color: #333333;
      font-weight: bold;
    }
  }
}

.play-record-content {
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 3.42rem;
    margin: 0.2rem 0.18rem 0 0;
    background: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #d5d5d5;
    border-radius: 0.08rem;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  .item-img {
    /* width 3.56rem */
    cursor: pointer;
    position: relative;
    height: 2.02rem;
    border-top-left-radius: 0.08rem;
    border-top-right-radius: 0.08rem;
    background: url('/static/peopleCenter/item.png') no-repeat;
    background-size: 100%;
  }

  .content {
    padding: 0 0.2rem;
    color: #333333;

    .top {
      font-size: 0.22rem;
      font-weight: bold;
      margin-top: 0.16rem;
      height: 0.6rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      /* autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      -webkit-line-clamp: 2;
    }
  }

  .center {
    color: #777777;
    margin-top: 0.06rem;
    font-size: 0.14rem;
  }

  .bottom {
    display: flex;
    border-top: 1px solid #F4F4F4;
    justify-content: space-between;
    line-height: 0.55rem;
    margin-top: 0.2rem;

    .bottom-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 1.86rem;

      img {
        border-radius: 50%;
        width: 0.26rem;
        height: 0.26rem;
      }
    }

    .operate-wrap {
      font-size: 0.16rem;
      line-height: 0.55rem;
      display: flex;

      img {
        margin: -0.02rem 0.03rem 0 0;
      }

      .delete-one {
        cursor: pointer;
        margin-left: 0.1rem;
      }

      .editIMG {
        width: 0.16rem;
        height: 0.16rem;
      }

      .deleteIMG {
        width: 0.13rem;
        height: 0.13rem;
      }
    }

    .error {
      color: #ff0000;
    }
  }
}

.body{
  background: #FAFAFA;
}
.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;
}

.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/time.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}

.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.18rem;
  background: url('/static/explore/visit.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/zan.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.18rem;
  background: url('/static/explore/comment.png') no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}

.order .active-time {
  background: url('/static/explore/focusTime.png') no-repeat center center;
  background-size: contain;
}

.order .active-visit {
  background: url('/static/explore/focusVisit.png') no-repeat center center;
  background-size: contain;
}

.order .active-zan {
  background: url('/static/explore/focusZan.png') no-repeat center center;
  background-size: contain;
}

.order .active-comment {
  background: url('/static/explore/focusComment.png') no-repeat center center;
  background-size: contain;
}

/* joincompetition style */
.joincompetition {
  color: #333;
  margin-top: 20px;
  font-size: 12px;
}

.joincompetition table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 14px;
}

.joincompetition table thead {
  color: #999;
  font-size: 12px;
}

.joincompetition table thead ~ tr td {
  padding: 13px 0;
}

.joincompetition table thead ~ tr {
  border-bottom: 1px solid #f5f5f5;
}

.joincompetition .width32 .matchName {
  font-weight: bold;
  color: #333;
}

.joincompetition .videoName {
  color: #333;
}

.joincompetition .width32 {
  width: 32%;
  padding-right: 20px;
  box-sizing: border-box;
}

.joincompetition .width32>a {
  display: block;
  color: #446EEB;
}

.joincompetition .width32>a.disabled {
  color: #999;
}

.joincompetition .operate>a.disabled {
  color: #999;
}

.joincompetition .width32>p {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: block-axis;
  white-space: normal;
  max-width: 400px;
  word-break: break-word;
  display: -webkit-box;
}

.joincompetition .width16 {
  width: 16%;
}

.joincompetition .width12 {
  width: 12%;
}

.joincompetition .width8 {
  width: 8%;
}

.joincompetition .operate a {
  color: #446EEB;
  cursor: pointer;
}

.joincompetition .operate a:first-child {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/activity/Competition.vue